import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PageShell from '../../components/PageShell';
import Tabs from '../../components/Tabs';
import { resolveTabs } from '../../i18n/resolveTabs';
import CostPoolsPage from '../tdabc/CostPoolsPage';
import PeoplePage from '../tdabc/PeoplePage';

/* Paramétrage TDABC (module ABC) — structure des pools. Sous-onglets :
     • Cost pools          → pools TDABC + driver
     • People assignment   → affectation collaborateurs ↔ pools
   L'Indirect assignment (cascade des charges indirectes) et le Temps standard
   sont dans « Coût horaire (CCR) » ; le Prix standard est un onglet de
   « Saisie des données ».
   Gabarit unique : <PageShell framed> + <Tabs> + sous-pages en mode embedded ;
   année globale portée par le PageHeader (cluster à droite du titre). */
const TAB_DEFS = [
  { id: 'pools',       labelKey: 'people:analytics.tabs.pools' },
  { id: 'assignment',  labelKey: 'people:analytics.tabs.assignment' },
];

export default function AnalyticsHubPage({ activeTenant, addToast, year }) {
  const { t } = useTranslation();
  const [tab, setTab] = useState('pools');
  const TABS = resolveTabs(TAB_DEFS, t);

  return (
    <PageShell
      framed
      title={t('people:analytics.title')}
    >
      <Tabs
        tabs={TABS}
        active={tab}
        onChange={setTab}
      />

      <div className="page-shell__panel">
        {tab === 'pools' && (
          <CostPoolsPage embedded activeTenant={activeTenant} addToast={addToast} />
        )}
        {tab === 'assignment' && (
          <PeoplePage embedded activeTenant={activeTenant} addToast={addToast} year={year} />
        )}
      </div>
    </PageShell>
  );
}
